var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1PLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7522 31.8097H9.98806V16.0789C9.98806 15.7888 9.98806 15.2594 9.98806 14.4906C9.98806 13.7073 9.99535 12.8443 10.0099 11.9015C10.0391 10.9586 10.0755 10.1101 10.1192 9.3558C9.74036 9.80546 9.38339 10.1898 9.04827 10.509C8.72772 10.8281 8.41445 11.1254 8.10847 11.401L4.48042 14.3818L0 8.89889L10.9716 0H18.7522V31.8097Z",
    fill: "#FFD822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9918 20C23.0725 20 25 21.6213 25 24.2454C25 26.8529 23.0725 28.4741 19.9918 28.4741H17.6689V31.7H15V20H19.9918ZM19.8435 26.2679C21.4745 26.2679 22.2982 25.5157 22.2982 24.2454C22.2982 22.9584 21.4745 22.2063 19.8435 22.2063H17.6689V26.2679H19.8435Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6689 32.825H18.7939V31.7V29.5991H19.9918C21.7193 29.5991 23.2538 29.1444 24.3765 28.1975C25.5211 27.2321 26.125 25.8477 26.125 24.2454C26.125 22.637 25.5227 21.2482 24.3777 20.2797C23.2546 19.3297 21.7192 18.875 19.9918 18.875H15H13.875V20V31.7V32.825H15H17.6689ZM21.1732 24.2454C21.1732 24.6244 21.0609 24.7852 20.9557 24.8743C20.8208 24.9885 20.505 25.1429 19.8435 25.1429H18.7939V23.3313H19.8435C20.5052 23.3313 20.8192 23.4857 20.9531 23.5998C21.058 23.6891 21.1732 23.8536 21.1732 24.2454Z",
    stroke: "#1B1B1C",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1PLogo);
export default __webpack_public_path__ + "static/media/1PLogo.3fae4bd911f923541197a254e7a637ec.svg";
export { ForwardRef as ReactComponent };